/**
 * Cookie CRUD utility — pure cookie operations, no test logic.
 * Single Responsibility: only knows how to read/write/init cookies.
 */

const ABCookies = {
  /**
   * @param {string} name
   * @returns {string|null}
   */
  get(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|;\\s*)' + name + '=([^;]*)')
    );
    return match ? match[1] : null;
  },

  /**
   * @param {string} name
   * @param {string} value
   * @param {number} days
   */
  set(name, value, days) {
    let expires = '';
    if (days) {
      const d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    const host = window.location.hostname;
    const domain =
      host === 'localhost' || host === '127.0.0.1' || host.startsWith('127.')
        ? ''
        : '; domain=.' + host.split('.').slice(-2).join('.');
    document.cookie = name + '=' + value + expires + domain + '; path=/';
  },

  /**
   * Expire a cookie by setting it with a past date.
   * Covers current host and parent domain (e.g. .ussportscamps.com).
   *
   * @param {string} name
   */
  remove(name) {
    const host = window.location.hostname;
    const parentDomain =
      host === 'localhost' || host === '127.0.0.1' || host.startsWith('127.')
        ? ''
        : '; domain=.' + host.split('.').slice(-2).join('.');
    const expired = '; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = name + '=' + expired + '; path=/';
    if (parentDomain) {
      document.cookie = name + '=' + expired + parentDomain + '; path=/';
    }
  },

  /**
   * Initialize a cookie with random value if it doesn't exist.
   * URL param with the same name overrides the cookie.
   *
   * @param {string} name
   * @param {object} options
   * @param {string[]} options.values — possible values
   * @param {number} options.days — cookie lifetime
   * @returns {string}
   */
  init(name, { values, days }) {
    // URL param override (e.g. ?ab_hero=1)
    try {
      const params = new URLSearchParams(window.location.search);
      const paramValue = params.get(name);
      if (paramValue !== null && values.indexOf(paramValue) !== -1) {
        this.set(name, paramValue, days);
        return paramValue;
      }
    } catch (e) {
      // URLSearchParams not supported — skip
    }

    // Existing cookie
    const existing = this.get(name);
    if (existing !== null) {
      return existing;
    }

    // Random assignment
    const value = values[Math.floor(Math.random() * values.length)];
    this.set(name, String(value), days);
    return String(value);
  },
};

export default ABCookies;
